import React from 'react';
import {FlexRow, Modal, Text} from '@forecast-it/design-system';
import {FormattedMessage, useIntl} from 'react-intl';

type DeleteDeliverableConfirmationModalProps = {
	closeModal: () => void;
	handleDelete: () => void;
	hasEstimates?: boolean | 'unknown';
};

const DeleteDeliverableConfirmationModal = ({
	closeModal,
	handleDelete,
	hasEstimates,
}: DeleteDeliverableConfirmationModalProps): JSX.Element => {
	const intl = useIntl();

	const confirmationMessage =
		hasEstimates === 'unknown'
			? intl.formatMessage({id: 'deliverables.delete_confirmation.modal.warning_3'})
			: hasEstimates
			? intl.formatMessage({id: 'deliverables.delete_confirmation.modal.warning_1'})
			: intl.formatMessage({id: 'deliverables.delete_confirmation.modal.warning_2'});
	return (
		<Modal size={Modal.SIZE.SMALL} onCloseModal={closeModal}>
			<Modal.Title>{intl.formatMessage({id: 'deliverables.delete_confirmation.modal.delete_deliverable'})}</Modal.Title>
			<Modal.Content>
				<Text>{confirmationMessage}</Text>
				<FlexRow>
					<Modal.PrimaryFooterButton onPress={handleDelete} dataCy="delete">
						<FormattedMessage id="deliverables.delete_confirmation.modal.confirm_delete" />
					</Modal.PrimaryFooterButton>
					<Modal.SecondaryFooterButton onPress={closeModal} dataCy="cancel">
						<FormattedMessage id="common.cancel" />
					</Modal.SecondaryFooterButton>
				</FlexRow>
			</Modal.Content>
		</Modal>
	);
};

export default DeleteDeliverableConfirmationModal;
